import React, { useEffect } from 'react';

const MapHandler = ({ map, gpxCoordinates, mapCenter }) => {
  useEffect(() => {
    if (!map) return;

    // Handle GPX coordinates - fit map bounds to show all track points
    if (gpxCoordinates && gpxCoordinates.length > 0) {
      const bounds = new window.google.maps.LatLngBounds();
      gpxCoordinates.forEach((coord) => {
        bounds.extend(new window.google.maps.LatLng(coord.lat, coord.lng));
      });
      map.fitBounds(bounds);
    }
  }, [map, gpxCoordinates, mapCenter]);

  return null;
};

export default React.memo(MapHandler);
